<template>
    <pre v-if="code">
        <code :class="`language-${language}`" v-html="highlightedCode"></code>
    </pre>
</template>
<script>
import Prism from 'prismjs';
import 'prismjs/components/prism-csharp.js';
import 'prismjs/components/prism-javascript.js';
import 'prismjs/components/prism-python.js';
// C++ is dependent on C (duh, I guess.)
import 'prismjs/components/prism-c.js';
import 'prismjs/components/prism-cpp.js';

export default {
    props: {
        code: String,
        language: {
            type: String,
            default: 'javascript'
        }
    },
    computed: {
        highlightedCode() {
            if (Prism.languages[this.language]) {
                require(`prismjs/components/prism-${this.language}.js`);
            }

            return Prism.highlight(this.code, Prism.languages[this.language], this.language);
        }
    }
}
</script>